import React from 'react';

/**
 * The Shopstar 4-point sparkle / "+" mark, as inline SVG so colour is
 * controllable. Echoes the logo mark. Decorative by default (aria-hidden).
 */
const Sparkle = ({ size = 24, color = 'currentColor', className, style }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    aria-hidden="true"
    focusable="false"
    style={style}
  >
    <path
      d="M50 0C53.5 28 72 46.5 100 50C72 53.5 53.5 72 50 100C46.5 72 28 53.5 0 50C28 46.5 46.5 28 50 0Z"
      fill={color}
    />
  </svg>
);

export default Sparkle;
